export const getPureErrorMessage = (v) => {
  if (Array.isArray(v)) return getPureErrorMessage(v[0]);
  if (typeof v === 'object') return getPureErrorMessage(Object.values(v)[0]);

  return v || 'Error';
};
